import React, { useEffect, useState, useContext } from 'react'
import { AuthContext } from '@/layout/Auth'
import { Message, Icon } from '@cx/ui'
import { Button, Stack, TextField, MenuItem, IconButton } from '@mui/material'
import { inviteMembers, getPermissions, validateMember } from '@/api'
import { PermissionInfo } from '@/types'
import { Controller, useForm, useFieldArray } from 'react-hook-form'
import Modal2 from '@/components/Modal2'
import EditPermissionModal from './EditPermissionModal'
interface AddUserModalProps {
  open: boolean
  onCancel: () => void
  onOk: () => void
}

const emailTest = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g

const AddUserModal: React.FC<AddUserModalProps> = ({ open, onCancel, onOk }) => {
  const { authInfo } = useContext(AuthContext)
  const [visible, setVisible] = useState(false)
  const orgInfo = authInfo?.orgInfo
  const [userIndex, setUserIndex] = useState(0)
  const [list, setList] = useState<PermissionInfo[]>([])
  const {
    control,
    watch,
    setError,
    formState: { errors, isValid },
    handleSubmit,
    reset,
  } = useForm({
    defaultValues: {
      data: [{ user_id: '', id: '', perm_ids: [] as number[], err: '' }],
    },
  })

  const watchData = watch('data')

  const { fields, append, remove, update } = useFieldArray({
    control,
    name: 'data',
  })

  const onSubmit = handleSubmit((data) => {
    console.log(data)
    if (data.data.filter((item) => !!item.err).length) return

    inviteMembers({
      id: orgInfo?.id!,
      users: data.data.map((item) => ({ user_id: item.id, perm_ids: item.perm_ids })),
    }).then(() => {
      Message.success('添加成功')
      onOk()
      onCancel()
    })
  })

  const onValidate = async (value: string, index: number) => {
    if (value.length === 0) return
    validateMember(orgInfo?.id!, {
      mail: emailTest.test(value) ? value : null,
      user_id: emailTest.test(value) ? null : value,
    })
      .then((res) => {
        // @ts-ignore
        update(index, { ...watchData[index], err: '', id: res.id })
      })
      .catch((err) => {
        // setError(`data.${index}.user_id`, { type: 'custom', message: err as string })
        update(index, { ...watchData[index], err })
      })
  }

  useEffect(() => {
    if (open) {
      getPermissions({ id: orgInfo?.id!, query: {} }).then((res) => {
        setList(res.data || [])
      })
    } else {
      reset()
    }
  }, [open])

  return (
    <Modal2 title='添加用户' width={1016} open={open} onCancel={onCancel} onOk={onSubmit}>
      <EditPermissionModal
        list={list}
        open={visible}
        onCancel={() => setVisible(false)}
        onOk={(ids) => {
          update(userIndex, { ...watchData[userIndex], perm_ids: ids })
        }}
      />
      <Stack gap={3}>
        {fields.map((field, index) => (
          <Stack key={field.id} direction='row' alignItems='flex-start' gap={3}>
            <Controller
              rules={{ required: '请输入用户 ID / 邮箱' }}
              name={`data.${index}.user_id`}
              control={control}
              render={({ field }) => (
                <TextField
                  required
                  {...field}
                  sx={{ height: 66 }}
                  variant='outlined'
                  fullWidth
                  placeholder='请输入用户 ID / 邮箱'
                  label='用户 ID / 邮箱'
                  error={Boolean(errors.data?.[index]?.user_id) || Boolean(watchData[index]?.err)}
                  helperText={(errors.data?.[index]?.user_id?.message as string) || watchData[index]?.err}
                  size='small'
                  autoComplete='off'
                  onBlur={(e) => onValidate(e.target.value, index)}
                />
              )}
            />
            <Controller
              rules={{ required: '请选择权限' }}
              name={`data.${index}.perm_ids`}
              control={control}
              render={({ field }) => (
                <TextField
                  required
                  {...field}
                  select
                  sx={{ height: 66 }}
                  SelectProps={{
                    multiple: true,
                    open: false,
                    onOpen: () => {
                      setUserIndex(index)
                      setVisible(true)
                    },
                    displayEmpty: true,
                  }}
                  variant='outlined'
                  placeholder='请选择权限'
                  label='权限'
                  fullWidth
                  error={Boolean(errors.data?.[index]?.perm_ids)}
                  helperText={errors.data?.[index]?.perm_ids?.message as string}
                  size='small'
                  autoComplete='off'
                >
                  {list.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.name}
                    </MenuItem>
                  ))}
                </TextField>
              )}
            />
            {fields.length > 1 && (
              <IconButton onClick={() => remove(index)}>
                <Icon type='icon-shanchu' />
              </IconButton>
            )}
          </Stack>
        ))}
        <Button
          variant='outlined'
          fullWidth
          onClick={() => {
            append({ user_id: '', perm_ids: [], id: '', err: '' })
          }}
        >
          添加用户
        </Button>
      </Stack>
    </Modal2>
  )
}

export default AddUserModal
